// src/components/ToastHost.tsx
import { useEffect, useRef } from "react";
import { Toast } from "primereact/toast";
import type { ToastMessage } from "primereact/toast";
import { useToastStore } from "../../../stores/toastStore";
import "./ToastHost.scss";
// optional: dedup to avoid spam in dev/StrictMode
function useDedup(ms = 1200) {
	const seen = useRef<Map<string, number>>(new Map());
	return (msgs: ToastMessage[]) => {
		const now = Date.now();
		const filtered = msgs.filter((m) => {
			const key = JSON.stringify([m.severity, m.summary, m.detail]);
			const last = seen.current.get(key) ?? 0;
			if (now - last > ms) {
				seen.current.set(key, now);
				return true;
			}
			return false;
		});
		return filtered;
	};
}

export function ToastHost() {
	const toastRef = useRef<Toast>(null);
	const queue = useToastStore((s) => s.queue);
	const flush = useToastStore((s) => s.flush);
	const dedup = useDedup(3000);

	useEffect(() => {
		if (!queue.length) return;
		const toShow = dedup(flush()); // read & clear the queue
		if (toShow.length) {
			// PrimeReact Toast accepts an array to show them in order
			toastRef.current?.show(toShow);
		}
	}, [queue, flush, dedup]);

	return <Toast ref={toastRef} position="bottom-right" />;
}
